// extracted by mini-css-extract-plugin
module.exports = {"shadow":"browse_shadow__2clpZ","textShadow":"browse_textShadow__2jtH6","page":"browse_page__AxwkV"};